import PageHeader from "@/components/shared/PageHeader";

const TYPEFORM_URL = "https://form.typeform.com/to/USifxL6I";

export default function BecomeCreator() {
  return (
    <div data-testid="page-become-creator">
      <PageHeader
        eyebrow="For creators"
        title="Get paid to post the music you already love."
        description="Prulo runs campaigns for the biggest labels and artists in the world. If you make short-form video on TikTok, Reels, or Shorts, apply below to join our roster. Direct rates, direct pay, no middlemen."
      />

      <section className="pb-16 md:pb-24">
        <div className="mx-auto max-w-5xl px-6 md:px-10">
          <div
            className="relative rounded-3xl overflow-hidden border border-white/10 bg-zinc-950"
            data-testid="creator-typeform-embed"
          >
            <iframe
              src={TYPEFORM_URL}
              title="Become a Prulo creator"
              className="w-full h-[720px] md:h-[820px] block"
              allow="camera; microphone; autoplay; encrypted-media; fullscreen"
              loading="lazy"
            />
          </div>

          <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-sm text-zinc-500">
            <div>Form not loading? Open it directly on Typeform.</div>
            <a
              href={TYPEFORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="creator-typeform-external"
              className="text-white hover:underline"
            >
              Open form in a new tab →
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
